import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'smFilter' })
export class SmFilterPipe implements PipeTransform {
	transform(items: any[], field: string, value: string, condition: boolean = true): any[] {
		if (!items) { return []; }

		if (condition) {
			return items.filter(it => it[field] == value);
		}
		else {
			return items.filter(it => it[field] != value);
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/pipes/sm-filter.pipe.ts